import React from "react";

/**
 * One labelled group of sidebar nav items.
 *
 * Every item inside is permission-gated (`{can('x') && <button/>}`), so a user
 * who holds none of a group's permissions would otherwise be left with a
 * heading floating over empty space — and, in the collapsed rail, a stray
 * divider line from `.sidebar-section + .sidebar-section::before`.
 *
 * React.Children.toArray() drops the `false`/`null` those gates produce (and
 * JSX comments), so "no items survived their permission checks" reduces to an
 * empty child list and the whole group renders nothing. Deriving it from the
 * children rather than a separate boolean keeps the two from drifting when an
 * item is added or its gate changes.
 */
export default function SidebarSection({ label, children }) {
  if (React.Children.toArray(children).length === 0) return null;

  return (
    <div className="sidebar-section">
      <div className="sidebar-section-label">{label}</div>
      {children}
    </div>
  );
}
